import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Chat = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24 12.1V9C24 6.237 21.762 4 19 4H9C6.237 4 4 6.237 4 9V21C4 22.65 5.35 24 7 24C7.8 24 8.563 23.687 9.125 23.125L10.7 21.55C11.575 23.025 13.175 24.012 15 24.012H18.512C19.312 24.012 20.062 24.325 20.637 24.887L22.875 27.125C23.438 27.688 24.2 28 25 28C26.65 28 28 26.65 28 25V17C28 14.588 26.275 12.562 24 12.1ZM7.713 21.712C7.525 21.9 7.275 22 7 22C6.45 22 6 21.55 6 21H6.013C6.013 20.975 6 9 6 9C6 7.35 7.35 6 9 6H19C20.65 6 22 7.35 22 9V13C22 14.65 20.65 16 19 16H15.488C14.15 16 12.9 16.525 11.951 17.462L7.714 21.712H7.713ZM26 25C26 25.55 25.55 26 25 26C24.738 26 24.475 25.9 24.288 25.712L22.05 23.474C21.1 22.524 19.85 22.012 18.512 22.012H15C13.713 22.012 12.613 21.199 12.187 20.062L13.362 18.887C13.925 18.324 14.687 18.012 15.487 18.012H18.999C21.362 18.012 23.362 16.362 23.874 14.137C25.112 14.512 25.999 15.662 25.999 17.012C25.999 17 25.999 24.975 25.999 25H26Z" />
	</svg>
);

export default Chat;
